import React from 'react';
import { object, string, array } from 'yup';
import { Formik, Form } from 'formik';
import { useHistory, Link } from 'react-router-dom';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import { resolveTo, initFormValues } from '~/commons/helpers';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpSaveBtn from '~/commons/components/FormHttpSaveBtn.jsx';
import { env } from '~/commons/config';

import _ from 'lodash';
import BtnDel from '../btns/BtnDel.jsx';

const schema = object({
  title: string().required(),
  subjects: array().of(string().required()),
});
const defaults = {
  title: '',
  coverImg: null,
  subjects: [],
  content: '',
  attachment: null,
};

const FormArticle = ({ article }) => {
  const history = useHistory();
  const [res, req] = useHttpStatus({
    onSuccess({ data }) {
      if (!article) {
        history.push(resolveTo(`../${data[0]._id}`));
      }
    },
  });

  return (
    <Formik
      validationSchema={schema}
      initialValues={initFormValues(defaults, article, {
        omitIds: false,
      })}
      onSubmit={async (values, actions) => {
        const v = { ...values };

        if (v.attachment) v.attachment = v.attachment._id;

        const { status } = await req({
          method: article ? 'patch' : 'post',
          url: `api/quiz/articles${article ? `/${article._id}` : ''}`,
          data: v,
        });

        if (status === 'success') {
          actions.setSubmitting(false);
          actions.resetForm({ values });
        }
      }}
    >
      <Form>
        <div className="form-row mb-3">
          <div className="col-auto">
            <FormHttpSaveBtn res={res} highlight />
          </div>
          {article && (
            <div className="col-auto">
              <Link to={resolveTo('./preview')} className="btn btn-secondary">
                <FA icon={faEye} />
                &nbsp; Preview
              </Link>
            </div>
          )}
          <div className="col"></div>
          {article && (
            <div className="col-auto">
              <BtnDel
                api={{ url: `api/quiz/articles/${article._id}` }}
                onDel={() => {
                  history.push(resolveTo('../'));
                }}
              />
            </div>
          )}
        </div>
        <FormHttpAlert res={res} />
        <div className="row">
          <div className="col">
            <FormGroup name="title" required />
            <FormGroup
              name="attachment"
              as="file"
              api={'api/quiz/articles/files'}
            />
            <div className="form-group">
              <label>Subjects *</label>

              {Object.keys(env.subjects)
                .sort(
                  (a, b) => (env.subjects[a].sort_order || 0)
                    - (env.subjects[b].sort_order || 0),
                )
                .map((key) => (
                  <FormCheckGroup
                    key={key}
                    name="subjects"
                    type="checkbox"
                    value={key}
                    label={env.subjects[key].zhhk || ''}
                  />
                ))}
            </div>
          </div>
          <div className="col">
            <FormGroup
              name="coverImg"
              as="coverImg"
              label="Cover Image (suggested dimension: 1200 x 675px)"
              api={'api/quiz/articles/files'}
            />
          </div>
        </div>

        <FormGroup
          name="content"
          as="summernote"
          fileUploadUrl={'api/quiz/articles/files'}
        />
      </Form>
    </Formik>
  );
};

export default FormArticle;
